<template>
  <div class="home1">
    <!--充值提醒-->
    <div class="let-top" v-if="showLeft">
      <div style="height: 13px;text-align: right"><i style="padding-top: 3px;cursor: pointer" class="el-icon-close" @click="showLeft = false"></i>&nbsp;&nbsp; </div>
      <div style="height: 50px;margin: 0 20px">
        <div style="float: left">
          <i v-if="role === 'op'" style="color: #ffc637;font-size: 30px;padding-top: 5px;" class="el-icon-warning"></i>
          <img v-else src="../assets/SIM.png">
        </div>
        <div style="float: left;margin-left: 20px">
          <p v-if="role === 'op'" style="color: #1a1a1a">信息提醒</p>
          <p v-else style="color: #1a1a1a">充值提醒</p>
          <span v-if="role === 'op'" style="color: #666666;font-size: 14px">当前有未审核信息，请及时处理。</span>
          <span v-else style="color: #666666;font-size: 14px">当月有SIM卡过期，请及时处理。</span>
        </div>
      </div>
      <div class="go-page" @click="openSimPage">前往处理</div>
    </div>
    <!--缴费提醒-->
    <div class="let-top" v-if="showMoney">
      <div style="height: 13px;text-align: right"><i style="padding-top: 5px;cursor: pointer" class="el-icon-close" @click="showMoney = false"></i>&nbsp;&nbsp; </div>
      <div style="height: 50px;margin: 0 20px">
        <div style="float: left">
          <img src="../assets/money.png">
        </div>
        <div style="float: left;margin-left: 20px">
          <p style="color: #1a1a1a">缴费提醒</p>
          <span style="color: #666666;font-size: 14px">当月有缴费过期，请及时处理。</span>
        </div>
      </div>
      <div class="go-page" @click="openPaymentPage">前往处理</div>
    </div>
    <!--通话视频提醒-->
    <div :class="showLeft ? 'let-top-call' : 'let-top-call1'" v-if="callLeft">
      <div style="height: 50px;margin: 0 20px;padding-top: 10px">
        <el-row>
          <el-col :span="4">
            <img style="width: 30px;padding-top: 10px" src="../assets/video.png">
          </el-col>
          <el-col :span="20">
            <p style="color: #1a1a1a;font-size: 16px">通话视频提醒</p>
            <span style="color: #666666;font-size: 14px">收到 {{callPerson.name}}-{{callPerson.deviceid}} 的呼叫，是否需要接听？</span>
          </el-col>
        </el-row>
      </div>
      <div class="accept-call" @click="sendZg(0)">接 听</div>
      <div class="close-call" @click="sendZg(1)">拒 绝</div>
    </div>
    <audio v-if="show" :src="urlLine === 'ryhf.jiaold.com' ? '/static/audio/alarm.mp3' : '/static/audio/alarmsound.mp3'" muted autoplay="autoplay" loop="loop" />
    <audio v-if="showPhoneVoice" src="../../../static/phone/phone.mp3" muted autoplay="autoplay"  loop="loop"/>

    <div class="nav-bar">
      <nav-bar></nav-bar>
    </div>
    <div style="height: calc(100% - 70px);padding-top: 10px">
     <div class="yanglaoyuan" style="height: 100%">
       <div class="left-nav" v-if="!($route.path === '/dataScreen' || $route.path === '/monitor') && scene !== 2">
         <div style="height: 100%;overflow: hidden;transition: width 0.5s;" :style="{width: isCollapse ? '64px' : '230px'}">
           <menu-bar ref="barShow"></menu-bar>
         </div>
       </div>
       <div class="right-nav">
         <div style="height: 33px;">
           <org-nav-wrap @changeMenu="changeMenu"></org-nav-wrap>
         </div>
         <div class="view-container">
           <router-view/>
         </div>
       </div>
     </div>
    </div>
    <!--全局電話呼入-->
    <el-dialog :visible.sync="phoneinShow" v-if="phoneinShow" width="1250px" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false"
      center top="6vh" class="all-open">
      <phone-in-alarm :phoneObj="phoneObj" v-model="phoneinShow"></phone-in-alarm>
    </el-dialog>
  </div>
</template>

<script>
import navBar from '../components/navbar/index'
import phoneInAlarm from './components/phoneInAlarm'
import navWrap from '../components/navbar/childNavBar/navWrap'
import orgNavWrap from '../components/navbar/childNavBar/orgNavWrap'
import menuBar from './components/menuBar'
import {querysimcardvaliddate} from '../api/topUp'
import {updatecalllist} from '../api/csdsip'
import {querycheckinfovaliddate} from '../api/alarmservice'
import {receivedeicevideo} from '../api/zego'
import {sendSub} from '../mq'
import {queryunhanlealarmbyalarmid} from '../api/handlealarm'
import {querydevicebydids} from '../api/device'
import {querypersoncarefeeremindervaliddate} from '../api/serviceMark'

export default {
  name: 'home',
  components: {navBar, phoneInAlarm, navWrap, orgNavWrap, menuBar},
  data () {
    return {
      urlLine: '',
      mqtts: [],
      scene: '',
      showMoney: false,
      showLeft: false,
      isShangHai: true,
      role: '',
      show: false,
      phoneinShow: false,
      phoneObj: {
        alarmRow: '',
        alarmMsg: '',
        isTable: false,
        types: [],
        supplierorg: [],
        projects: [],
        typeOrg: [],
        orgcommunitys: []
      },
      // 即构视频
      showPhoneVoice: false, // 响铃
      callLeft: false,
      sTime: 0,
      callPerson: {
        name: '呼叫者',
        roomid: ''
      },
      mqtimer: null,
      moduletag: '',
      isCollapse: false,
      // 左侧菜单
      isPathId: '',
      menuList: []
    }
  },
  created () {
    this.urlLine = window.location.host
    this.mqtts = this.$store.state.user.mqtts
    this.scene = this.$store.state.user.scene
    this.moduletag = this.$store.state.user.moduletag
    this.isShangHai = this.$store.state.user.isShangHai
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const day = new Date().format('dd')
    let number = day.split('')
    let arr = [1, 3, 5, 7, 9]
    if (arr.indexOf(parseInt(number[1])) > -1) {
      this.$store.commit('set_evenNumber', true)
    } else {
      this.$store.commit('set_evenNumber', false)
    }
    this.golobleObject.phoneInCall = this.getOpenShow
    this.golobleObject.openPhoneCall = this.tableOpen
    this.golobleObject.getAudioPlay = this.playAudio
    this.golobleObject.updatePhone = this.getUpdateCallList
    this.golobleObject.mqttVideoCall = this.mqttZg
    this.golobleObject.getChangeMenu = this.getChangeMenu // 一级菜单切换
    this.golobleObject.getChangeLevel2 = this.changeMenu
    this.role = this.$store.state.user.role

    let aa = window.location.host
    if ((this.role === 'admin' || this.role === 'superadmin' || this.role === 'op') && this.$store.state.user.moduletag !== 2 &&
      aa !== 'newjky.wecare-u.net' && aa !== 'newhealth.wecare-u.net' && aa !== 'kangnh.com' && aa !== 'bengshan.kangnh.com') { // 上海更换
      // 查询缴费提醒
      this.getMoney()
    }
    if ((this.role === 'admin' || this.role === 'superadmin') && this.$store.state.user.moduletag !== 2) {
      //  newjky域名下且登录账号的mqttlevel 是 /1/14时，才显示页面
      let bb = '/1/14'
      if ((aa === 'newjky.wecare-u.net' || aa === 'newhealth.wecare-u.net' || aa === 'kangnh.com' || aa === 'bengshan.kangnh.com') &&
        this.$store.state.user.mqtts.indexOf(bb) > -1) { // 上海
        this.getSim() // 查询sim卡过期
      }
    }
    if (this.$store.getters.get_path) {
      this.getGoPath()
    } else {
      if (this.role === '') {
        this.$router.push({path: '/'})
      }
    }
    if (this.role === 'op') {
      this.getCheck() // 查询是否有未批准审核信息
    } else if (this.role === 'guest' && this.moduletag === 2) { // 养老院 护工账号默认左侧菜单
      this.menuList = [
        {
          path: '',
          name: '护理服务',
          isOpen: true,
          icon: '/static/menuIcon/hlfw.png',
          lists: [
            {id: 18, level1: 6, path: '/serviceProject', name: '护理项目', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
            {id: 39, level1: 6, path: '/serviceRecord', name: '护理记录', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
          ]
        },
        {
          path: '',
          name: '用药提醒',
          isOpen: true,
          icon: '/static/menuIcon/yytx.png',
          lists: [
            {id: 44, level1: 6, path: '/medicationRegistration', name: '用药登记', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'},
            {id: 45, level1: 6, path: '/todayReminder', name: '当日提醒', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
          ]
        },
        {
          path: '',
          name: '工作管理',
          isOpen: true,
          icon: '/static/menuIcon/yytx.png',
          lists: [
            {id: 53, level1: 6, path: '/dayWork', name: '电子排班', icon1: '/static/menuIcon/select_no.png', icon2: '/static/menuIcon/select_check.png'}
          ]
        }
      ]
    } else if (this.role === 'company') {
      this.golobleObject.getGoCheck(3)
      this.$store.commit('set_is_indexActive', 3)
    }
    this.isPathId = this.$store.getters.get_is_indexPathId === '' ? 44 : this.$store.getters.get_is_indexPathId // 养老院 护工账号默认左侧菜单
  },
  mounted () {
  },
  computed: {
    isRoute () {
      return this.$route.path
    },
    menuLists () {
      return this.menuList
    }
  },
  watch: {
    isRoute: {
      deep: true,
      handler () {
        this.getRoutePath()
      }
    },
    menuLists: {
      deep: true,
      handler () {
        this.getmenuLists()
      }
    }
  },
  destroyed () {
    this.$store.commit('set_is_mqtt', false)
    this.store2.dispatch('other/update_zg_info', '')
  },
  methods: {
    getmenuLists () {
      console.log('this.menuList', this.menuList)
    },
    changeMenu (obj) { // 二级菜单点击切换页面
      if (obj.type === 'isCollapse') {
        this.$refs.barShow.getCollapse()
        this.isCollapse = !this.isCollapse
        for (let i = 0; i < this.menuList.length; i++) {
          if (this.menuList[i].name !== '') {
            this.menuList[i].isOpen = false
          }
        }
      } else if (obj.type === 'path') { // 点击orgNavWrap
        let vm = this
        setTimeout(() => {
          if (!(this.$route.path === '/dataScreen' || this.$route.path === '/monitor')) { // 数据大屏不显示左侧菜单
            vm.$refs.barShow.getMenuList1(this.menuList)
          }
        }, 100)
        let isChange = ''
        for (let i = 0; i < this.menuList.length; i++) {
          for (let j = 0; j < this.menuList[i].lists.length; j++) {
            if (obj.path === this.menuList[i].lists[j].path) {
              isChange = this.menuList[i].lists[j].id
            }
          }
        }
        this.isPathId = isChange
        this.$store.commit('set_is_indexPathId', this.isPathId)
        this.golobleObject.getChangeTab(this.menuList) // orgNavBottom.vue
      }
    },
    getChangeMenu (item, path) {
      // 一级菜单切换跳转路由
      // console.log(666, item.arr, this.$route.path)
      if (item.title === '数据大屏' || (this.moduletag !== 2 && item.title === '运营看板')) {
        this.$router.push({path: item.path})
        this.isCollapse = false // 默认展开
        return
      }
      this.menuList = item.arr
      let vm = this
      setTimeout(() => {
        if (!(this.$route.path === '/dataScreen' || this.$route.path === '/monitor')) { // 数据大屏不显示左侧菜单
          vm.$refs.barShow.getMenuList(item)
        }
      }, 100)
      if (path) { // 数据大屏 切换其他菜单默认第一个页面
        this.isPathId = item.arr[0].lists[0].id
        this.$router.push({path: item.arr[0].lists[0].path})
        this.$store.commit('set_is_indexPathId', this.isPathId)
        return
      }
      let isChange = ''
      for (let i = 0; i < this.menuList.length; i++) {
        for (let j = 0; j < this.menuList[i].lists.length; j++) {
          if (this.$route.path === this.menuList[i].lists[j].path) {
            isChange = this.menuList[i].lists[j].id
          }
        }
      }
      this.isPathId = isChange
      this.$store.commit('set_is_indexPathId', this.isPathId)
    },
    // 即构mqtt推送
    mqttZg (obj) {
      if (obj.datatype === 'phoneVoice') { // 是否响铃
        this.showPhoneVoice = obj.isShow
      } else if (obj.datatype === 'callLeft') { // 是否弹窗
        this.callLeft = obj.isShow
      } else if (obj.datatype === 'callvideo') { // 一个设备只能一个人接听
        if (obj.roomid === this.callPerson.roomid || obj.result === 1) {
          clearTimeout(this.mqtimer)
          this.showPhoneVoice = false
          this.callLeft = false
          this.callPerson = {
            name: '呼叫者',
            roomid: ''
          }
        }
      } else if (obj.datatype === 'rtccallin') { // 设备拨打进来
        if (!this.$store.getters.get_is_mqtt) {
          this.callPerson = obj
          if (!this.callLeft) {
            this.showPhoneVoice = true
            this.callPerson = obj
            this.callLeft = true
            this.mqtimer = setTimeout(() => {
              this.sendZg(3)
            }, 40000)
          }
        }
      } else if (obj.datatype === 'rtccalloutresult') { // 未接通挂断
        clearTimeout(this.mqtimer)
        if (parseInt(obj.resulttype) === 1 || parseInt(obj.resulttype) === 2 || parseInt(obj.resulttype) === 3) {
          this.showPhoneVoice = false
          this.callLeft = false
        }
      } else if (obj.datatype === 'rtccalltime') { // 结束弹窗通话时长
        if (obj.roomid === this.callPerson.roomid) {
          this.$store.commit('set_is_mqtt', false)
          this.store2.dispatch('other/update_zg_info', '')
          this.roomID = ''
          let aa = '时长： ' + obj.calltime + '秒。  分辨率： ' + obj.resolution + '。'
          this.$message({
            dangerouslyUseHTMLString: true,
            message: '<strong>' + aa + '</strong>',
            duration: 4000
          })
          this.callPerson = {
            name: '呼叫者',
            roomid: ''
          }
        }
      }
    },
    // 即构视频
    sendZg (val) {
      clearTimeout(this.mqtimer)
      if (parseInt(val) === 0) {
        let bb = {deviceid: this.callPerson.deviceid, roomid: this.callPerson.roomid, result: 0}
        let mqtts = this.$store.state.user.mqtts
        sendSub('callvideo' + mqtts[0], JSON.stringify(bb))
        this.$store.commit('set_is_mqtt', true)
        this.store2.dispatch('other/update_zg_info', this.callPerson)
        if (this.$route.path === '/videoZg') { // 在视频页
          if (this.$store.state.user.moduletag !== 2) {
            this.$router.push({path: '/videoZg', query: {deviceid: this.callPerson.deviceid}})
          }
          let obj = {datatype: 'videoZg', deviceid: this.callPerson.deviceid}
          this.golobleObject.mattVideoCallPage(obj)
        } else { // 其他页
          this.$router.push({path: '/videoZg', query: {deviceid: this.callPerson.deviceid}})
        }
        return
      }
      this.callLeft = false
      this.showPhoneVoice = false
      //  "result”:”0”   回复结果, result: 0 接听，1拒接，2对方忙, 3对方未接
      let data = {
        deviceid: this.callPerson.deviceid,
        name: this.callPerson.name,
        videotype: 'video',
        roomid: this.callPerson.roomid,
        result: val + ''
      }
      // console.log(data)
      receivedeicevideo(data).then(res => {
        let cc = {deviceid: this.callPerson.deviceid, roomid: this.callPerson.roomid, result: 1}
        let mqtts = this.$store.state.user.mqtts
        sendSub('callvideo' + mqtts[0], JSON.stringify(cc))
        this.callPerson = {
          name: '呼叫者',
          roomid: ''
        }
        this.$store.commit('set_is_mqtt', false)
        this.store2.dispatch('other/update_zg_info', '')
      }).catch(() => {})
    },
    getCheck () {
      querycheckinfovaliddate().then(res => {
        if (res.data.cnt > 0) {
          this.showLeft = true
        }
      }).catch(() => {})
    },
    getUpdateCallList (sessionid) {
      // console.log(sessionid)
      if (sessionid && this.$store.state.user.sipinfo.syspersonid) {
        let data = {
          sessionid: sessionid,
          sp_id: this.$store.state.user.sipinfo.syspersonid
        }
        updatecalllist(data).then(res => {}).catch(() => {})
      }
    },
    getSim () {
      querysimcardvaliddate().then(res => {
        // console.log('sim卡过期', res.data.cnt)
        if (res.data.cnt > 0) {
          this.showLeft = true
        }
      }).catch(() => {})
    },
    openSimPage () {
      if (this.role === 'op') {
        this.$router.push({path: '/checkData'})
        this.golobleObject.getGoCheck(2)
        this.$store.commit('set_is_indexActive', 2)
      } else {
        this.$router.push({path: '/stateRefillCard', query: {history: true}})
      }
      this.showLeft = false
    },
    getMoney () {
      querypersoncarefeeremindervaliddate().then(res => {
        if (res.data.cnt > 0 && this.$route.path !== '/chargeReminder') {
          this.showMoney = true
        }
      }).catch(() => {})
    },
    openPaymentPage () {
      this.showMoney = false
      this.golobleObject.changeMoney()
      this.$router.push({path: '/chargeReminder'})
    },
    getRoutePath () {
      let path = this.$route.path
      let role = this.$store.state.user.role
      let customerservicetag = this.$store.state.user.customerservicetag
      let moduletag = this.$store.state.user.moduletag
      let isOpenRoute = this.routejs.isOpenRoute(path, role, customerservicetag, moduletag)
      if (!isOpenRoute) {
        history.back()
      }
    },
    playAudio (msgJson) {
      let vm = this
      this.show = true
      if (this.$store.state.user.mqtts.indexOf('/1/11') > -1) {
        // 荣逸泓福 不需要播报
        setTimeout(() => {
          vm.show = false
        }, 12000)
      } else if (this.$store.state.user.mqtts.indexOf('/1/14') > -1) {
        // 上海客户不需要播报
        setTimeout(() => {
          vm.show = false
        }, 3000)
      } else {
        // jiaold 居家养老院都需要
        setTimeout(() => {
          vm.show = false
          if (msgJson && msgJson !== '') {
            // 养老院进行tts播报
            vm.playTts(msgJson.alarmid)
          }
        }, 3000)
      }
    },
    async playTts (alarmid) {
      let alarm = ''
      let text = ''
      let body = {
        alarmid: alarmid
      }
      await queryunhanlealarmbyalarmid(body).then(async res => {
        alarm = res.data.alarm[0]
        alarm.alarmtypedesc = this.commonType.getAlarmType(alarm.alarmtype)
        text = '发生' + alarm.alarmtypedesc
        await querydevicebydids({dids: [alarm.did]}).then(res => {
          let device = res.data.devices[0]
          alarm.build_name = device.build_name
          alarm.floor_name = device.floor_name
          alarm.home_room = device.home_room
          alarm.devicetype = device.devicetype
          alarm.devicetypedesc = alarm.devicetype === 700 ? '智能网关' : ((alarm.devicetype === 310 || alarm.devicetype === 311 || alarm.devicetype === 312) ? '四级手表' : this.commonType.getDeviceType(alarm.devicetype))
          // h_installlocation o_installlocation p_name三种设备类型只会有一个有值
          if (this.$store.state.user.moduletag === 2) {
            // 养老院
            let aa = ''
            let bb = device.h_installlocation + device.o_installlocation
            let cc = device.p_name
            if (alarm.sub_deviceid !== '' && device.sub_devices && device.sub_devices.length > 0) {
              let types = this.commonType.getChildDtpyeArr()
              for (let i = 0; i < device.sub_devices.length; i++) {
                if (alarm.sub_deviceid === device.sub_devices[i].sub_deviceid) {
                  bb = device.sub_devices[i].remark
                  types.forEach(sub => {
                    if (device.sub_devices[i].sub_type === sub.value) {
                      alarm.devicetypedesc = alarm.devicetypedesc + '下的' + sub.label
                    }
                  })
                }
              }
            }
            if (bb !== '') {
              aa = '位于'
            }
            text = alarm.build_name + alarm.floor_name + alarm.home_room + '房号' + aa + bb + cc + '的' + alarm.devicetypedesc.replace('-', '') + '设备发生' + alarm.alarmtypedesc
          } else {
            text = alarm.floor_name + device.h_address + device.h_installlocation + device.o_installlocation + device.p_name + '的' + alarm.devicetypedesc.replace('-', '') + '设备发生' + alarm.alarmtypedesc
          }
        }).catch(() => {})
      }).catch(() => {})
      // 'speechSynthesis' in window
      if (text && text !== '' && 'speechSynthesis' in window) {
        let utterance = new SpeechSynthesisUtterance(text)
        utterance.lang = 'zh-CN'
        utterance.rate = 1.2
        utterance.pitch = 1.2
        // 获取声音列表并设置声音
        speechSynthesis.addEventListener('voiceschanged', () => {
          let voices = speechSynthesis.getVoices()
          utterance.voice = voices[0]
          // 65
        })
        speechSynthesis.speak(utterance)
      }
    },
    getGoPath () {
      this.$store.commit('set_path', false)
      this.role = this.$store.state.user.role
      if (this.role === 'csd') {
        if (this.$store.state.user.moduletag === 2) { // 养老院 值班员 账号
          this.$router.push({path: '/dataScreen'})
          this.$store.commit('add_tabs', {route: '/dataScreen', name: '数据大屏'})
          this.$store.commit('set_active_index', '/dataScreen')
        } else { // 客服
          this.$router.push({path: '/handleAlarm'})
          this.$store.commit('add_tabs', {route: '/handleAlarm', name: '事件处理'})
          this.$store.commit('set_active_index', '/handleAlarm')
        }
      } else if (this.role === 'company') {
        this.$router.push({path: '/serviceOrder'})
        this.$store.commit('add_tabs', {route: '/serviceOrder', name: '服务商接单'})
        this.$store.commit('set_active_index', '/serviceOrder')
      } else if (this.role === '') {
        this.$router.push({path: '/'})
      } else {
        if (this.$store.state.user.moduletag === 2) { // 养老院
          if (this.role === 'guest') {
            this.$router.push({path: '/medicationRegistration'})
            this.$store.commit('add_tabs', {route: '/medicationRegistration', name: '用药登记'})
            this.$store.commit('set_active_index', '/medicationRegistration')
            this.$store.commit('set_is_indexActive', 6)
          } else {
            this.$router.push({path: '/dataScreen'})
            this.$store.commit('add_tabs', {route: '/dataScreen', name: '数据大屏'})
            this.$store.commit('set_active_index', '/dataScreen')
          }
        } else {
          this.$router.push({path: '/monitor'})
          this.$store.commit('add_tabs', {route: '/monitor', name: '运营看板'})
          this.$store.commit('set_active_index', '/monitor')
        }
      }
    },
    getOpenShow (obj) {
      this.phoneObj.alarmMsg = obj
      this.phoneObj.isTable = false
      this.phoneinShow = true
    },
    tableOpen (obj) {
      this.phoneObj.alarmRow = obj.alarmRow
      this.phoneObj.isTable = true
      this.phoneObj.types = obj.types
      this.phoneObj.supplierorg = obj.supplierorg
      this.phoneObj.projects = obj.projects
      this.phoneObj.typeOrg = obj.typeOrg
      this.phoneObj.orgcommunitys = obj.orgcommunitys
      this.phoneinShow = true
    }
  }
}
</script>

<style scoped>
.yanglaoyuan{
  display: flex; /* 使用弹性布局，使子元素较为灵活地填充 */
  height: 100%;
}
.left-nav{
  height: 100%;
  overflow-y: auto;
}
.right-nav{
  height: 100%;
  overflow-y: auto;
  flex: 2;
}
  .home1{
    width: 100%;
    height: 100%;
    background: url("../assets/SHscreen/index_bg.png") no-repeat center;
    overflow-y: hidden;
  }
.nav-bar{
  width: 100%;
  height: 60px;
}
  .view-container{
    margin-top: 2px;
    height: calc(100% - 35px);
    width: 100%;
    overflow-y: hidden;
  }
  .let-top-call{
    position: absolute;
    z-index: 2030;
    top: 150px;
    left: 20px;
    transition: opacity .3s,transform .3s,left .3s,right .3s,top .4s,bottom .3s;
    width: 300px;
    height: 130px;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1px solid  rgba(219, 222, 224, 0.5);
    box-shadow: 0px 0px 10px rgba(219, 222, 224, 0.5);
  }
  .let-top-call1{
    position: absolute;
    z-index: 2030;
    top: 30px;
    left: 20px;
    transition: opacity .3s,transform .3s,left .3s,right .3s,top .4s,bottom .3s;
    width: 300px;
    height: 130px;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1px solid  rgba(219, 222, 224, 0.5);
    box-shadow: 0px 0px 10px rgba(219, 222, 224, 0.5);
  }
  .let-top{
    position: absolute;
    z-index: 2030;
    top: 30px;
    left: 20px;
    transition: opacity .3s,transform .3s,left .3s,right .3s,top .4s,bottom .3s;
    width: 300px;
    height: 100px;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 0px 20px 0px
    rgba(255,198,55, 0.3);
  }
  .go-page{
    float: right;
    margin-right: 20px;
    cursor: pointer;
    width: 100px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    color: #ffffff;
    background-image: linear-gradient(0deg,
    #e5b332 0%,
    #ffc637 100%);
    border-radius: 13px;
  }
  .close-call{
    float: right;
    margin-right: 20px;
    cursor: pointer;
    width: 80px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    color: #999999;
    background-color: rgba(219, 222, 224, 0.6);
    border-radius: 13px;
  }
  .accept-call{
    float: right;
    margin-right: 20px;
    cursor: pointer;
    width: 80px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    color: #3980F1;
    background-color: rgba(84, 145, 224, 0.2);
    border-radius: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/view/home.vue